import type {
  InboxFiltersInput,
  AmpTaskRowFragment,
  AmpTasksBoolExp,
} from "src/graphql";
import {
  assignedTo,
  OPEN_PROJECTS_TASKS,
  OPEN_TASK,
} from "src/pages/projects/task-query";
import { isTaskCompleted } from "src/pages/projects/utils";

type Task = Pick<
  AmpTaskRowFragment,
  | "assignees"
  | "due_at"
  | "status"
  | "status_category"
  | "deleted_at"
  | "updated_at"
>;

function time(iso: string): number {
  return new Date(iso).getTime();
}

/** Soonest due first; undated after, most recently touched first. */
function byUrgency(a: Task, b: Task): number {
  if (a.due_at && b.due_at) return time(a.due_at) - time(b.due_at);
  if (a.due_at) return -1;
  if (b.due_at) return 1;
  return time(b.updated_at) - time(a.updated_at);
}

/** Open tasks, most urgent first. */
export function openTasksByUrgency<T extends Task>(tasks: T[]): T[] {
  return tasks.filter((task) => !isTaskCompleted(task)).sort(byUrgency);
}

// The server's side of each card, which loads only its first few tasks and counts the rest.
export function assignedToMeWhere(userId: string): AmpTasksBoolExp {
  return { _and: [OPEN_PROJECTS_TASKS, OPEN_TASK, assignedTo(userId)] };
}

/** Each list keeps what matches any of its values; an empty list keeps everything. */
export type InboxFilters = InboxFiltersInput;

export const NO_INBOX_FILTERS: InboxFilters = {
  types: [],
  sources: [],
  projectIds: [],
  fileIds: [],
};

export function inboxFilterCount(filters: InboxFilters): number {
  return (
    filters.types.length +
    filters.sources.length +
    filters.projectIds.length +
    (filters.fileIds?.length ?? 0)
  );
}
